import { createSlice } from "@reduxjs/toolkit";

export const documentSlice = createSlice({
  name: "documents",
  initialState: {
    loading: false,
    error: null,
    documents: [],
    taxForm:{
    }
  },
  reducers: {
    getAllDocumentsStart(state, action) {
      state.loading = true;
      state.documents = [];
    },
    getAllDocumentsSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.documents = action.payload;
    },
    getAllDocumentsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getAllTaxFormDocumentsStart(state, action) {
      state.loading = true;
      state.taxForm ={};
    },
  getAllTaxFormDocumentsSuccess(state, action) {
  state.loading = false;
  state.error = null;
  state.taxForm = {
    ...state.taxForm,
    ...(action.payload || {}), // fallback in case payload is undefined
  };
},

    addW4FormDocumentsStart(state,action){
      state.loading=false;
    },
    getplacementDocumentsStart(state,action){
      state.loading=false;
    },
    clearDocuments(state) {
      state.loading = false;
      state.error = null;
      state.documents = [];
      state.taxForm = {
      };
    }
  },
});

export const {
  getAllDocumentsStart,
  getAllDocumentsSuccess,
  getAllDocumentsFailure,
  getAllTaxFormDocumentsStart,
  getAllTaxFormDocumentsSuccess,
  addW4FormDocumentsStart,
  getplacementDocumentsStart,
  clearDocuments
} = documentSlice.actions;

export default documentSlice.reducer;
